import { combineReducers, createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';
import { thunk } from 'redux-thunk';
import coreReducers from './reducers';
import adminReducers from '../Admin/store/reducers';
import managerRequestsReducers from '../Manager/Requests/reducers';
import employeeDashboardReducers from '../App/reducers';

const middleware = [thunk];

const createAppStore = (store) => createStore(
    store,
    composeWithDevTools(applyMiddleware(...middleware)),
);

const createAppReducer = (reducer) => combineReducers({
    ...coreReducers,
    ...reducer,
});

const adminStoreReducer = createAppReducer(adminReducers);
const managerStoreReducer = createAppReducer(managerRequestsReducers);
const employeeDashboardStoreReducer = createAppReducer(employeeDashboardReducers);

export const adminStore = createAppStore(adminStoreReducer);
export const managerStore = createAppStore(managerStoreReducer);
export const employeeDashboardStore = createAppStore(employeeDashboardStoreReducer);
